import 'js-offcanvas/dist/_js/js-offcanvas.pkgd';
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $('#stats-canvas').offcanvas({
      modifiers: 'left, overlay',
      triggerButton: '.trigger-canvas'
    });

    $( '.trigger-canvas' ).offcanvasTrigger( { offcanvas: "stats-canvas" });
    $( document ).trigger( "enhance" );
  }
}